import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import '../../../styles/components/Notifications.scss';

const Notifications: React.FC = () => {
    const [teamMembers, setTeamMembers] = useState<string[]>([]);
    const [newMember, setNewMember] = useState<string>('');
    const [notifiedMembers] = useState<string[]>(['john@example.com', 'jane@example.com']);
    const [pendingRequests] = useState<string[]>(['Request 1', 'Request 2']);

    const handleAddMember = () => {
        if (newMember) {
            setTeamMembers([...teamMembers, newMember]);
            setNewMember('');
        }
    };

    const handleRemoveMember = (member: string) => {
        setTeamMembers(teamMembers.filter(m => m !== member));
    };

    const trafficData = {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        datasets: [
            {
                label: 'Check-ins',
                data: [12, 19, 3, 5, 2, 3, 9],
                fill: false,
                backgroundColor: '#FF6B6B',
                borderColor: '#FF6B6B',
            },
        ],
    };

    const trafficOptions = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <div className="notifications">
            <h1>Notifications & Staff Alerts</h1>
            <p>Add or remove team members who receive check-in alerts.</p>
            <div className="form-group">
                <label htmlFor="newMember">Add Team Member</label>
                <input
                    type="email"
                    id="newMember"
                    value={newMember}
                    onChange={(e) => setNewMember(e.target.value)}
                    placeholder="Enter team member's email"
                />
                <button className="btn" onClick={handleAddMember}>Add</button>
            </div>
            <ul>
                {teamMembers.map(member => (
                    <li key={member}>
                        {member}
                        <button onClick={() => handleRemoveMember(member)}>Remove</button>
                    </li>
                ))}
            </ul>
            <h2>Notified Members Today</h2>
            <ul>
                {notifiedMembers.map(member => (
                    <li key={member}>{member}</li>
                ))}
            </ul>
            <h2>Traffic Overview</h2>
            <div className="chart">
                <Line data={trafficData} options={trafficOptions} />
            </div>
            <h2>Pending Requests</h2>
            <ul>
                {pendingRequests.map(request => (
                    <li key={request}>{request}</li>
                ))}
            </ul>
        </div>
    );
};

export default Notifications;